import { Component, EventEmitter, Input, OnInit, Output, Type, ViewChild } from '@angular/core';
import { UiService } from 'app/modules/shared/services/ui.service';
import { ManageOpenShiftsService } from '../../services/manage-open-shifts.service';
import * as moment from 'moment-timezone';
import { AppSettings } from 'app/modules/shared/app.settings';
import { ActivatedRoute } from '@angular/router';
import { StorageService } from 'app/modules/shared/services/storage.service';
import { OverlayPanel } from 'primeng/overlaypanel';
interface Event {
  date: string;
  title: string;
}
@Component({
  selector: 'app-manage-shift-monthly-calender',
  templateUrl: './manage-shift-monthly-calender.component.html',
  styleUrls: ['./manage-shift-monthly-calender.component.scss']
})
export class ManageShiftMonthlyCalenderComponent implements OnInit {
  currentDate: Date;
  displayedMonth: Date;
  selectedAvailability: any[] = [];
  offset = '';
  searchTeam = '';
  selectedRole = '';
  userRoleIds: any[] = [];
  limit = '';
  sortType = '';
  userId;
  teamMemberList: any[] = [];
  memberShiftAvailabilityList: any[] = [];
  calenderDays: any[] = [];
  firstDayFormatted;
  lastDayFormatted;
  selectedTeam: any;
  displayDialog = false;
  teamMemberDetailsList: any[] = [];
  activeDay: any = null;
  isVisible = true;
  groupTeamName;
  selectedTeam1: any = null;
  groupedData: any[] = [];
  @ViewChild('op', { static: false }) op: OverlayPanel | undefined;
  @Input() content!: Type<any>;
  @Input() style: any = {
    'border': '0',
    'border-radius': '5px',
    'color': '#333',
    'overflow': 'auto',
    'witdh': '98%',
    'height': 'auto'
  };

  @Output() closePopup = new EventEmitter<void>();
  @Input() visible = false;
  @Output() close = new EventEmitter<void>();

  constructor(private manageOpenShiftsService: ManageOpenShiftsService,
    private uiService: UiService,
    private storageService: StorageService,
    private route: ActivatedRoute, ) {
    this.currentDate = new Date();
    this.displayedMonth = new Date();
    window['page'] = this;

  }

  ngOnInit(): void {
    const userIdFromSession = sessionStorage.getItem('currentId');
    this.userId = userIdFromSession ? userIdFromSession : null;
    this.getDaysArray();
    this.getFirstAndLastDayOfMonthFormatted();
    if (this.userId) {
      this.getTeamMemberList();
    }

    const tagsData = this.storageService.getItem(AppSettings.TAG_DATA);
    this.setDropdownValues(tagsData);


  }

  getDaysInMonth(month: number, year: number): number {
    return new Date(year, month + 1, 0).getDate();
  }

  setDropdownValues(tagsData?) {
    tagsData?.teams_member_availability.forEach(element => {
      this.memberShiftAvailabilityList.push({
        label: element.tagValue,
        value: this.convertToCssClass(element.tagValue)
      });
    });

    this.memberShiftAvailabilityList = this.memberShiftAvailabilityList.slice(0, 3);

    console.log('memberShiftAvailabilityList', this.memberShiftAvailabilityList);
  }

  convertToCssClass(className: string) {
    const lowerCaseClass = className.split(' ').map((name) => name.toLowerCase());
    return lowerCaseClass.join('-');
  }
  getFirstDayOfMonth(month: number, year: number): number {
    return new Date(year, month, 1).getDay();
  }

  nextMonth(): void {
    const currentMonth = this.displayedMonth.getMonth();
    const currentYear = this.displayedMonth.getFullYear();
    const newMonth = currentMonth === 11 ? 0 : currentMonth + 1;
    const newYear = currentMonth === 11 ? currentYear + 1 : currentYear;
    this.displayedMonth = new Date(newYear, newMonth, 1);
    this.getDaysArray();
    this.getFirstAndLastDayOfMonthFormatted();
    this.getTeamMemberList();

  }

  previousMonth(): void {
    const currentMonth = this.displayedMonth.getMonth();
    const currentYear = this.displayedMonth.getFullYear();
    const newMonth = currentMonth === 0 ? 11 : currentMonth - 1;
    const newYear = currentMonth === 0 ? currentYear - 1 : currentYear;
    this.displayedMonth = new Date(newYear, newMonth, 1);
    this.getDaysArray();
    this.getFirstAndLastDayOfMonthFormatted();
    this.getTeamMemberList();

  }

  isToday(day: number): boolean {
    return (
      day === this.currentDate.getDate() &&
      this.displayedMonth.getMonth() === this.currentDate.getMonth() &&
      this.displayedMonth.getFullYear() === this.currentDate.getFullYear()
    );
  }

    getDaysArray() {
      const daysArray = [];
      const totalDays = this.getDaysInMonth(this.displayedMonth.getMonth(), this.displayedMonth.getFullYear());

      // Get the first day index of the month (0 = Sunday, 1 = Monday, etc.)
      const firstDayIndex = new Date(this.displayedMonth.getFullYear(), this.displayedMonth.getMonth(), 1).getDay();
      console.log('firstDayIndex', firstDayIndex);

      // Adjusting for December 2nd to start on Monday
      // If the first day of the month is not Monday (index 1), we need to adjust the firstDayIndex accordingly
      const adjustedFirstDayIndex = firstDayIndex === 0 ? 7 : firstDayIndex;  // if Sunday (0), treat it as index 7

      // Adding empty null days to align the first day
      for (let i = 1; i < adjustedFirstDayIndex; i++) {
        daysArray.push(null);
      }

      // Loop through all days in the month
      for (let day = 1; day <= totalDays; day++) {
        const date = new Date(this.displayedMonth);
        date.setDate(day);
        const dayObject = {
          calenderDay: day,
          date: date
        };
        daysArray.push(dayObject);
      }

      console.log('daysArray', daysArray);

      this.calenderDays = daysArray;
  }


  getTeamMemberList() {
    const formattedFromDate = this.firstDayFormatted;
    const formattedToDate = this.lastDayFormatted;
    const formattedStatusId = this.selectedAvailability.length ? this.selectedAvailability : '';

      this.manageOpenShiftsService.getTeamMemberMonth(formattedFromDate, formattedToDate, this.limit,
        this.offset, this.searchTeam, formattedStatusId, this.selectedRole, this.userRoleIds, this.sortType, 'month', this.userId)
        .subscribe((teamMemberDetails) => {
          console.log('teamMemberDetails', teamMemberDetails);
          console.log('teamMemberDetails', teamMemberDetails);
          this.teamMemberList = teamMemberDetails?.data;
          console.log('this.teamMemberList', this.teamMemberList);
          this.userForCalender(teamMemberDetails);
        },
          (error) => {
            this.uiService.showMessage(error.general[0].message, AppSettings.MESSAGE_TYPES.ERROR);

          });
      this.groupByTeamName();


  }

 /*    userForCalender(users: any) {
      console.log("users", users);

      users.data.forEach(user => {
        user.memberSchedules.forEach(schedule => {
          const userTeamDate = new Date(+schedule.date).getDate();
          console.log("userTeamDate", userTeamDate);

          let calenderDay = this.calenderDays.find(item => item?.calenderDay === userTeamDate);

          if (!calenderDay) {
            calenderDay = { calenderDay: userTeamDate, groupedTeams: [] };
            this.calenderDays.push(calenderDay);
          }

          if (!calenderDay.groupedTeams) {
            calenderDay.groupedTeams = [];
          }

          schedule.userTeams.forEach(team => {
            let groupedTeam = calenderDay.groupedTeams.find(t => t.teamName === team.teamName);

            if (!groupedTeam) {
              groupedTeam = {
                teamName: team.teamName,
                slots: [],
                leaveTypes: [],
                scheduleSource: team.scheduleSource
              };
              calenderDay.groupedTeams.push(groupedTeam);
            }


            if (team.leaveTypeId === "0") {
              if (team.slotTimeStr) {
                groupedTeam.slots.push(team.slotTimeStr);
              }
            } else {
              if (team.slotTimeStr) {
                groupedTeam.leaveTypes.push({
                  leaveType: team.leaveType,
                  slotTimeStr: team.slotTimeStr,

                });
              }
            }


          });


         calenderDay.memberStatusStr = schedule.memberStatusStr;
        });
      });

      console.log("Updated calenderDays:", this.calenderDays);
    } */

      userForCalender(users: any) {
        console.log('users', users);

        // Iterate over the users
        users.data.forEach(user => {
          user.memberSchedules.forEach(schedule => {
            const userTeamDate = new Date(+schedule.date).getDate();
            console.log('userTeamDate', userTeamDate);

            let calenderDay = this.calenderDays.find(item => item?.calenderDay === userTeamDate);

            // Create calenderDay if not found
            if (!calenderDay) {
              calenderDay = { calenderDay: userTeamDate, groupedTeams: [] };
              this.calenderDays.push(calenderDay);
            }

            // Ensure groupedTeams array exists
            if (!calenderDay.groupedTeams) {
              calenderDay.groupedTeams = [];
            }

            // Process each team in the schedule
            schedule.userTeams.forEach(team => {
              let groupedTeam = calenderDay.groupedTeams.find(t => t.teamName === team.teamName);

              // Create a new groupedTeam if not found
              if (!groupedTeam) {
                groupedTeam = {
                  teamName: team.teamName,
                  slots: [],  // Will store both slotTimeStr and scheduleSource
                  leaveTypes: []
                };
                calenderDay.groupedTeams.push(groupedTeam);
              }

              // Process leave types
              if (team.leaveTypeId === '0') {
                if (team.slotTimeStr) {
                  // Push slotTimeStr with scheduleSource into slots array
                  groupedTeam.slots.push({ slotTimeStr: team.slotTimeStr, scheduleSource: team.scheduleSource });
                }
              } else {
                if (team.slotTimeStr) {
                  groupedTeam.leaveTypes.push({
                    leaveType: team.leaveType,
                    slotTimeStr: team.slotTimeStr
                  });
                }
              }
            });

            // Optionally set memberStatusStr to calenderDay
            calenderDay.memberStatusStr = schedule.memberStatusStr;
          });
        });

        console.log('Updated calenderDays:', this.calenderDays);
      }


  groupByTeamName() {
    const grouped = [];
    this.groupTeamName?.forEach(item => {
      if (item.teamName) {
        let team = grouped.find(t => t.teamName === item.teamName);

        if (!team) {
          team = { teamName: item.teamName, slots: [] };
          grouped.push(team);
        }


        team.slots.push(item.slotTimeStr);
      }
    });

    this.groupedData = grouped;
    console.log(this.groupedData);
  }


  getFirstAndLastDayOfMonthFormatted() {
    const year = this.displayedMonth.getFullYear();
    const month = this.displayedMonth.getMonth();
    const firstDay = new Date(year, month, 1);
    console.log('firstDay', firstDay);
    const lastDay = new Date(year, month + 1, 0);
    console.log('lastDay', lastDay);

    this.firstDayFormatted = moment(firstDay).format('YYYY/MM/DD');
    this.lastDayFormatted = moment(lastDay).format('YYYY/MM/DD');

    console.log('this.firstDayFormatted', this.firstDayFormatted);
    console.log('this.lastDayFormatted', this.lastDayFormatted);
  }
  openDialog(day: any) {
    this.displayDialog = true;
    this.activeDay = day;
  }

  closeDialog() {
    this.displayDialog = false;
    this.activeDay = null;
  }

  toggleDialog(day: any): void {
    if (this.activeDay === day) {
      this.displayDialog = !this.displayDialog;
    } else {
      this.activeDay = day;
      this.displayDialog = true;
    }
  }

  closePopupCal() {
    this.visible = false;
    this.close.emit();
  }

  onClose() {
    this.closePopup.emit();
  }

  formatTeamName(teamName: string): string {

    if (/\d+$/.test(teamName)) {
      return teamName;
    }
    return teamName;
  }

  openTeamDetails(team: any) {
    this.selectedTeam = team;
  }


  isNullTeam(team: any) {
    return team.teamName === null;
  }

}
